<section class="playground">
  <h2 class="playground__heading">Botones</h2>
  <p class="playground__hint">
    Variantes: <code>common-buttons-filled</code>, <code>common-buttons-outlined</code>,
    <code>common-text-button</code> (misma API que outlined, sin borde ni fondo en hover),
    <code>common-secondary-buttons-filled</code>.
  </p>

  <p *ngIf="clickLog" class="playground__log">{{ clickLog }}</p>

  <div class="playground__sections">
    <!-- Filled -->
    <div class="playground__card">
      <h3 class="playground__card-title">common-buttons-filled</h3>
      <div class="playground__controls">
        <label class="playground__field">
          <span>label</span>
          <input type="text" [(ngModel)]="filledLabel" />
        </label>
        <label class="playground__field">
          <span>icon (ligature)</span>
          <input type="text" [(ngModel)]="filledIcon" />
        </label>
        <label class="playground__field">
          <span>typeIcon</span>
          <select [(ngModel)]="filledTypeIcon">
            <option *ngFor="let t of typeIcons" [value]="t">{{ t }}</option>
          </select>
        </label>
        <label class="playground__field">
          <span>iconSet</span>
          <select [(ngModel)]="filledIconSet">
            <option *ngFor="let i of iconSets" [value]="i">{{ i }}</option>
          </select>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="filledDisabled" />
          <span>disabled</span>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="filledIconPosition" />
          <span>iconPosition (true = icono izquierda)</span>
        </label>
      </div>
      <div class="playground__preview-box">
        <common-buttons-filled
          [label]="filledLabel"
          [icon]="filledIcon"
          [disabled]="filledDisabled"
          [typeIcon]="filledTypeIcon"
          [iconSet]="filledIconSet"
          [iconPosition]="filledIconPosition"
          (output)="log('filled')"
        ></common-buttons-filled>
      </div>
    </div>

    <!-- Outlined -->
    <div class="playground__card">
      <h3 class="playground__card-title">common-buttons-outlined</h3>
      <div class="playground__controls">
        <label class="playground__field">
          <span>label</span>
          <input type="text" [(ngModel)]="outlinedLabel" />
        </label>
        <label class="playground__field">
          <span>icon</span>
          <input type="text" [(ngModel)]="outlinedIcon" />
        </label>
        <label class="playground__field">
          <span>typeIcon</span>
          <select [(ngModel)]="outlinedTypeIcon">
            <option *ngFor="let t of typeIcons" [value]="t">{{ t }}</option>
          </select>
        </label>
        <label class="playground__field">
          <span>iconSet</span>
          <select [(ngModel)]="outlinedIconSet">
            <option *ngFor="let i of iconSets" [value]="i">{{ i }}</option>
          </select>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="outlinedDisabled" />
          <span>disabled</span>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="outlinedIconPosition" />
          <span>iconPosition</span>
        </label>
      </div>
      <div class="playground__preview-box">
        <common-buttons-outlined
          [label]="outlinedLabel"
          [icon]="outlinedIcon"
          [disabled]="outlinedDisabled"
          [typeIcon]="outlinedTypeIcon"
          [iconSet]="outlinedIconSet"
          [iconPosition]="outlinedIconPosition"
          (output)="log('outlined')"
        ></common-buttons-outlined>
      </div>
    </div>

    <!-- Text (sin borde / sin overlay hover) -->
    <div class="playground__card">
      <h3 class="playground__card-title">common-text-button</h3>
      <div class="playground__controls">
        <label class="playground__field">
          <span>label</span>
          <input type="text" [(ngModel)]="textLabel" />
        </label>
        <label class="playground__field">
          <span>icon</span>
          <input type="text" [(ngModel)]="textIcon" />
        </label>
        <label class="playground__field">
          <span>typeIcon</span>
          <select [(ngModel)]="textTypeIcon">
            <option *ngFor="let t of typeIcons" [value]="t">{{ t }}</option>
          </select>
        </label>
        <label class="playground__field">
          <span>iconSet</span>
          <select [(ngModel)]="textIconSet">
            <option *ngFor="let i of iconSets" [value]="i">{{ i }}</option>
          </select>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="textDisabled" />
          <span>disabled</span>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="textIconPosition" />
          <span>iconPosition</span>
        </label>
      </div>
      <div class="playground__preview-box">
        <common-text-button
          [label]="textLabel"
          [icon]="textIcon"
          [disabled]="textDisabled"
          [typeIcon]="textTypeIcon"
          [iconSet]="textIconSet"
          [iconPosition]="textIconPosition"
          (output)="log('text')"
        ></common-text-button>
      </div>
    </div>

    <!-- Secondary -->
    <div class="playground__card">
      <h3 class="playground__card-title">common-secondary-buttons-filled</h3>
      <div class="playground__controls">
        <label class="playground__field">
          <span>label</span>
          <input type="text" [(ngModel)]="secondaryLabel" />
        </label>
        <label class="playground__field">
          <span>icon (ligature o URL si customized)</span>
          <input type="text" [(ngModel)]="secondaryIcon" />
        </label>
        <label class="playground__field">
          <span>typeIcon</span>
          <select [(ngModel)]="secondaryTypeIcon">
            <option *ngFor="let t of secondaryTypeIcons" [value]="t">{{ t }}</option>
          </select>
        </label>
        <label class="playground__field">
          <span>iconSet (solo si no customized)</span>
          <select [(ngModel)]="secondaryIconSet">
            <option *ngFor="let i of iconSets" [value]="i">{{ i }}</option>
          </select>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="secondaryDisabled" />
          <span>disabled</span>
        </label>
        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="secondaryIconPosition" />
          <span>iconPosition</span>
        </label>
      </div>
      <div class="playground__preview-box">
        <common-secondary-buttons-filled
          [label]="secondaryLabel"
          [icon]="secondaryIcon"
          [disabled]="secondaryDisabled"
          [typeIcon]="secondaryTypeIcon"
          [iconSet]="secondaryIconSet"
          [iconPosition]="secondaryIconPosition"
          (output)="log('secondary')"
        ></common-secondary-buttons-filled>
      </div>
    </div>
  </div>
</section>
